/* eslint-disable */
import React, { useEffect, useState , } from "react";
import { translate } from "react-i18next";
import { Button, Grid, Icon, Input, Radio } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { ALL_ALLOW_ROLES, UPL_CUSTOMER } from '../../utils/constant';
import {ewaybill_title} from './ewayBillContants'

const TitleBarEwayBill = (props) => {
  const [ImportModalState, setImportModalState] = useState(false);
  const [createPermissionModalState, setcreatePermissionImportModalState] = useState(false);
  const [Permissions, setPermissions] = useState(false);
  const [showFilterDiv, setshowFilterDiv] = useState(false)

  const handleImportClose = () => {
    setImportModalState(false);
    window.location.reload();
  };

  const handleImportOpen = () => {
    setImportModalState(true);
  };

  let handleFilter = () => {
    setshowFilterDiv(!showFilterDiv)
  }

  const [invoiceNo, setInvoiceNo] = useState("")
  const [deliveryReferenceNo, setDeliveryReferenceNo] = useState("")


  const searchCall = () => {
    let searchElement = {
      delivery_reference_no: deliveryReferenceNo,
      invoice_no: invoiceNo,
    }
    props.handleMetaSearch(searchElement)
  }

  const { t } = props;
  return (
    <div id="dispatch_bar">
      <div className="container-fluid dip_bar">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between">
              <h2 className="page-title">{props.title}</h2>
              <div className="form-inline">
                {/* <span>{this.state.path}</span> */}
                {props.radioToggle && (
                  <Radio
                    toggle
                    className="mr-1"
                    name="gridView"
                    checked={props.toggle}
                    onChange={props.toggleView}
                  />
                )}

                {props?.showNewButton == true ?
                  <>
                    <Link
                          to={props.LinkName}
                          className="grey-btn-new"
                        >
                          <i className="fas fa-plus"></i>{" "}
                          {ewaybill_title.Buttons.new||"New"}
                        </Link>
                  </>
                  :
                  null
                }
                {!props.exportHidden ? <button
                  type="button"
                  data-toggle="modal"
                  data-target="#ExportXL"
                  // hidden={props.exportHidden}
                  onClick={props.exportDataGrid}
                  className="grey-btn"
                >
                  <i class="fas fa-file-export mr-1"></i>
                  {ewaybill_title.Buttons.export|| "Export"}
                </button>
                  : null}

                {ALL_ALLOW_ROLES ? (
                  <button size="mini" className="grey-btn-01 btn-font" onClick={handleFilter} color="#f1f1f1" icon >
                    <Icon name="filter" size="small" />
                    {ewaybill_title.Buttons.filter||"Filter"}
                  </button>
                ) : (null)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showFilterDiv == true ? (
        <>
          <div>
            <Grid style={{ margin: '0px', background: 'white', paddingLeft: '15px' }}>
              <Grid.Row>
                <Grid.Column width={3}>
                  <label>Delivery Reference No</label>
                  <Input type="text" placeholder=""
                    onChange={(e) => setDeliveryReferenceNo(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        searchCall()
                      }
                    }}
                  />
                </Grid.Column>
                <Grid.Column width={1}>
                </Grid.Column>
                <Grid.Column width={3}>
                  <label>Invoice No</label>
                  <Input type="text" placeholder=""
                    onChange={(e) => setInvoiceNo(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        searchCall()
                      }
                    }}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row centered>
                <Grid.Column width={2}>
                  <Button className="w3-button w3-small w3-border w3-blue w3-hover-blue ml-1 w3-round" onClick={searchCall}>Search</Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </>
      ) : null}
    </div>
  );
};
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
}
export default connect(mapStateToProps)(translate("title_bar")(TitleBarEwayBill));
